import { Grid,Select, MenuItem, TextField, InputLabel, Checkbox, ListItemText, Box, Skeleton, Typography ,ListSubheader} from '@mui/material'
import {React, useState, useEffect, forwardRef} from 'react'
import "./NotificationStyles.css"
import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'
import {notificationServices} from 'src/services/sales/notification/notification.service.ts'
import { useTranslate, useNotify, useRecordContext} from 'react-admin'
import DownloadIcon from '@mui/icons-material/Download';
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { getItemName } from '../../reservation/helper/getItemName'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';

const FormatHistoryNote = ({text}) =>{
        const maxTextLenght = 50
        const translate = useTranslate()
        const [completeText, setCompleteText] = useState(false)
        const [textArray, setTextArray] = useState([])

        useEffect(()=>{
            if(completeText){
                setTextArray(text.split('\n'))
            } else {
                const newText = text.slice(0, maxTextLenght)
                setTextArray(newText.split('\n'))
            }
        },[completeText])
        return(
            <>
                <label>
                    {` ${translate('ra.action.wrote')}: `}
                    {
                        textArray?.map((line, index)=>(
                            <div key={index}>  
                                {/* <br /> */}
                                {line}
                            </div>
                        ))
                    }
                    
                </label>
                {!completeText && text.length > maxTextLenght && 
                    <LoadingButton  onClick={()=>setCompleteText(true)}>
                        {
                        translate('ra.action.see_more')
                        }
                    </LoadingButton>
                }
                {completeText && text.length > maxTextLenght && 
                    <LoadingButton  onClick={()=>setCompleteText(false)}>
                        {
                        translate('ra.action.see_less')
                        }
                    </LoadingButton>
                }
            </>
        )
        
        
    }

export const NotificationForm = ({notificationId, mode, setDialogOpen, reload, setReload}) => {
    const navigate = useNavigate()
    const translate = useTranslate()
    const notify = useNotify()
    const record = useRecordContext()
    const [items, setItems] = useState(record?.items?.map(item=>{return {id:item.id, name:getItemName(item)}}))
    const [selectedFile, setSelectedFile] = useState([]);
    const fileInput = document.getElementById('fileInput');
    const [projects, setProjects] = useState([])
    const [memberships, setMemberships] = useState([])
    const [notification, setNotification] = useState(null)
    const [isFetchingData, setIsFetchingData] = useState(false)
    const [isSaveLoading, setIsSaveLoading] = useState(false)
    const [journals, setJournals] = useState([])
    const [reservationIDs, setReservationIDs] = useState([])
    const [formError, setFormError] = useState({
        project:false,
        subject:false
    })
    const [statuses, setStatuses] = useState([])
    const [reserves, setReserves] = useState([])
    const [openDetails, setOpenDetails] = useState(false)
    const [reservesFilter, setReservesFilter] = useState('')
    const [projectsLoading, setProjectsLoading] = useState(false)
    const [projectFilter, setProjectFilter] = useState('')
    const [filteredProjects, setFilteredProjects] = useState([])
    const [followersFilter, setFollowersFilter] = useState('')
    const [filteredFollowers, setFilteredFollowers] = useState([])
    const [membersFilter, setMembersFilter] = useState('')
    const [filteredItems, setFilteredItems] = useState([])
    const [itemsFilter, setitemsFilter] = useState('')
    const [filteredMembers, setFilteredMembers] = useState([])
    const [editFiles, setEditFiles] = useState(false)
    const [templates, setTemplates] = useState([])
    const [files, setFiles] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState('')
    const [form, setForm] = useState({
        project_id:'',
        assigned_to_id:'',
        watchers:[],
        subject:'',
        description:'',
        notes:'',
        tracker_id:17,
        status_id:1,
        priority_id:3,
        item:'',
        reservation:[],
        delete_attachment:[],
        link:''
    })
    const [originalWatchers, setOriginalWatchers] = useState([])

    const getProjects = async () =>{
        await notificationServices.getProjects().then((res)=>{
            setFilteredProjects(res.projects)
            setProjects(res.projects)
        })
    }

    const getFollowers = async () =>{
        if(form.project_id){
            await notificationServices.getFollowers(form.project_id).then((res)=>{
                setFilteredFollowers(res.memberships ?? [])
                setFilteredMembers(res.memberships ?? [])
                setMemberships(res.memberships)
            })
        }   
    }

    const downloadParticularFile = async (filename) =>{
        await notificationServices.downloadFile(notification.id, filename).then(async res=>{
            const url = URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        })
    }

    const getNotification = async () =>{
        setIsFetchingData(true)
        await notificationServices.getNotificationByParam({issueID:notificationId}).then((res)=>{
            setFiles(res.issue.attachments ?? [])
            setNotification(res.issue)
            setJournals(res.issue?.journals?.reverse())
            setOriginalWatchers(res.issue.watchers?.map(user=>user?.id))
        }).finally(()=>{
            setIsFetchingData(false)
        })
    }

    const handleChange = (value, field) =>{
        setForm({...form, [field]:value?.target?.value})
    }

    const TemplateComponent = ({field}) =>{
        return(
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'flex-end'}}>
                <InputLabel id="description">{field === 'message' ? translate('ra.field.message') :translate('ra.field.description')}</InputLabel>
                {((mode === 'reply' && field === 'message') || ((mode === 'edit' || mode === 'create') && field === 'description')) &&<Select
                    style={{width:'50%'}}
                    required
                    disabled = {mode === 'show'}
                    id='template'
                    size='small'
                    onChange={(value)=>{
                        const foundTemplate = templates.find(templ =>
                            templ.id === value.target?.value
                        )
                        setSelectedTemplate(value.target?.value)
                        const changeField = mode === 'reply' ? 'notes':'description'
                        setForm({...form, [changeField]:foundTemplate?.value})
                    }}
                    value={selectedTemplate}
                    defaultValue={''}
                    displayEmpty
                    renderValue={(value)=> {
                        if(value){
                            const foundTemplate = templates.find(templ =>
                                templ.id === value
                            )
                            return foundTemplate?.name
                        }
                        
                        return translate('ra.field.template')
                    }}
                >
                    {
                        templates?.map(template => (
            
                            <MenuItem key={template.id } value={template.id }>
                                {template.name}
                            </MenuItem>
                                
                        ))
                    }
                </Select>}
            </div>
        )
    }

    const searchReserveByNumber = (num) =>{
        return reserves.find(reserve => reserve.number === num)?.id
    }

    const removeFile = (filename) =>{
        
        const auxFiles = [...files]
        setFiles(auxFiles.filter(item => item.filename !== filename))
        const deleteAttachAux = form.delete_attachment.length > 0 ? [...form.delete_attachment] : []
        deleteAttachAux.push(filename)
        setForm({...form, delete_attachment:deleteAttachAux})
    }

    useEffect(()=>{
        if(projectFilter){
            setProjectsLoading(true)
            const handler = setTimeout(() => {
                /* setDebouncedValue(userFilter); */
                setFilteredProjects(projects.filter(project=>project.name.toLowerCase().includes(projectFilter.toLowerCase())))
            }, 500);
            setProjectsLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setFilteredProjects(projects)
        }
        
    },[projectFilter])

    useEffect(()=>{
        if(followersFilter){
            setProjectsLoading(true)
            const handler = setTimeout(() => {
                /* setDebouncedValue(userFilter); */
                setFilteredFollowers(memberships.filter(member=> member.user && member.user.name.toLowerCase().includes(followersFilter.toLowerCase())))
            }, 500);
            setProjectsLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setFilteredFollowers(memberships ?? [])
        }
        
    },[followersFilter])

    useEffect(()=>{
        if(membersFilter){
            setProjectsLoading(true)
            const handler = setTimeout(() => {
                /* setDebouncedValue(userFilter); */
                setFilteredMembers(memberships.filter(member=> (
                    member.user && member.user.name.toLowerCase().includes(membersFilter.toLowerCase())
                ) || (
                    member.group && member.group.name.toLowerCase().includes(membersFilter.toLowerCase())
                )))
            }, 500);
            setProjectsLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setFilteredMembers(memberships ?? [])
        }
        
    },[membersFilter])

    useEffect(()=>{
        if(itemsFilter){
            setProjectsLoading(true)
            const handler = setTimeout(() => {
                /* setDebouncedValue(userFilter); */
                setFilteredItems(items.filter(item=> (
                    item.name.toLowerCase().includes(itemsFilter.toLowerCase())
                )))
            }, 500);
            setProjectsLoading(false)
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setFilteredItems(items ?? [])
        }
        
    },[itemsFilter])

    useEffect(()=>{
        if(reservesFilter){
            setProjectsLoading(true)
            const handler = setTimeout(() => {
                reservationServices.getByAll({number__ilike:reservesFilter}).then((res)=>{
                    setProjectsLoading(false)
                    setReserves(res)
                })
                
            }, 500);
            return () => {
            clearTimeout(handler); // clear the timeout if user types again
            };
        } else {
            setReserves(form.reservation?.map(reser=>{const reserve = {number:reser}; return reserve}) ?? [])
        }
        
    },[reservesFilter])

    useEffect(()=>{
        if(notification){
            const custom_fields = notification.custom_fields
            const found_reservation = custom_fields?.find(field => field.id === 3)
            const reservation = found_reservation?.value ?? []
            const found_item = custom_fields?.find(field => field.id === 1)
            const item = found_item?.value ?? ''
            setReserves(reservation?.map(reser=>{const reserve = {number:reser}; return reserve}))
            setReservationIDs(reservation)
            setForm({
                project_id:notification.project?.id,
                assigned_to_id:'',
                watchers:[],
                subject:notification?.subject,
                description:notification?.description,
                status_id:notification?.status?.id,
                priority_id:3,
                reservation:reservation,
                item:item,
                delete_attachment:[]
                /* custom_fields:notification.custom_fields ?? [] */
            })
            
        }
    },[notification])

    const getStatuses = async () =>{
        await notificationServices.getStatuses().then((res)=>{
            setStatuses(res.issue_statuses)
        })
    }

    useEffect(()=>{
        if(items){
            setFilteredItems(items)
        }
        const fetchData = async () => {
            if(mode === 'edit' || mode === 'reply' || mode === 'show'){
                await getStatuses()
            }
            await getProjects()
            if(notificationId){
                await getNotification()
            }
        }
        fetchData();
    },[])

    useEffect(()=>{
        if(form.project_id){
            const project = projects.find((value)=>
                value.id === form.project_id
            )
            setSelectedTemplate('')
            setTemplates(project.custom_fields?.filter(template=>template.value.length > 0))
        }
        
        const fetchData = async () => {
            await getFollowers()
            if(notification){
                setForm({
                    ...form, 
                    assigned_to_id:notification.assigned_to?.id, 
                    watchers:notification.watchers?.map(user=>user?.id)
                })
            }
        }
        fetchData()
    },[form.project_id])


    const handleFileChange = (event) => {
        if(event.target.files[0]){
            let selectFile = [...selectedFile]
            selectFile.push(event.target.files[0])
            setSelectedFile(selectFile);
            setEditFiles(true)
            for(let aFile of files){
                if(aFile.filename === event.target.files[0].name){
                    removeFile(aFile.filename)
                }
            }
        }
    };

    const checkForm = () =>{
        if(mode === 'create' || mode === 'edit' || mode === 'reply'){
            return  (form.project_id && form.subject)
        }
        return mode === 'show'
    }

    const buildLinkOnReserves = () =>{
        const base_link = `${window.location.origin}/#/reservation/`
        const suffix_link = '/show/5'
        let linkParts  = []
        let link = ''
        if(reservationIDs.length > 0){
            for(let i = 0; i < reservationIDs.length; i++){
                linkParts.push(`${form.reservation[i]} - ${base_link}${reservationIDs[i]}${suffix_link}`);
            }
            link = linkParts.join(' --- ')
        } else {
            link = `${window.location.origin}/#/notification`
        }
        return link
    }

    const onSaveForm = async () =>{
        if(!checkForm()){
            setFormError({
                project:form.project_id ? false: true,
                subject:form.subject ? false: true
            })
            return
        }
        const formData = new FormData();
        let auxiliar_form = {...form}
        auxiliar_form.assigned_to_id = auxiliar_form.assigned_to_id === '' ? null : auxiliar_form.assigned_to_id
        if(mode === 'create' || mode === 'edit'){
            if(record){
                auxiliar_form.reservation = [record.number]
                auxiliar_form.link = `${window.location.origin}/#/reservation/${record.id}/show/5`
            } else {
                auxiliar_form.reservation = form.reservation.length > 0 ? form.reservation : ['']
                auxiliar_form.link = buildLinkOnReserves()
            }
        }
        formData.append('payload', JSON.stringify(auxiliar_form));

        if(fileInput?.files){
            for(let file of selectedFile){
                formData.append('attachments', file);
            }
        }
        setIsSaveLoading(true)
        if(mode == 'create'){
            await notificationServices.postNotification(formData).then(()=>{
                if(setReload){
                    setReload(!reload)
                }
                if(setDialogOpen){
                    setDialogOpen(false)
                } else {
                    navigate('/notification')
                }
                notify('ra.notification.regenerate_notification_to_success',{type: 'success'})
            }).finally(()=>{
                setIsSaveLoading(false)
            }).catch(()=>{
                notify('ra.notification.regenerate_notification_to_error',{type: 'error'})
            })
        } else if(mode == 'edit'){
            const watchersToRemove = originalWatchers.filter(watcher => !form.watchers.includes(watcher))
            for(let watcher of watchersToRemove){
                await notificationServices.removeWatcher(notificationId, watcher)
            }
            await notificationServices.editNotification(formData, notificationId).then(()=>{
                if(setReload){
                    setReload(!reload)
                }
                notify('ra.message.edit_notification_success', {type:'success'})
                if(setDialogOpen){
                    setDialogOpen(false)
                }
            }).finally(()=>{
                setIsSaveLoading(false)
            }).catch(()=>{
                notify('ra.message.edit_notification_error', {type:'error'})
            })
        } else if(mode == 'reply'){
            await notificationServices.editNotification(formData, notificationId).then(()=>{
                if(setDialogOpen){
                    setDialogOpen(false)
                }
                notify('ra.message.edit_notification_success', {type:'success'})
            }).finally(()=>{
                setIsSaveLoading(false)
            }).catch(()=>{
                notify('ra.message.edit_notification_error', {type:'error'})
            })
        } else {
            setIsSaveLoading(false)
            if(setDialogOpen){
                setDialogOpen(false)
            }
        }
        
    }
    const getUserGroupName = (detail) =>{
        const foundMember = memberships.find((user)=>
            user.user?.id === Number(detail.new_value) ||
            user.group?.id === Number(detail.new_value)
        )
        if(foundMember?.user){
            return foundMember.user.name
        }
        if(foundMember?.group){
            return foundMember.group.name
        }
        return ''
    }
  return (
    <div >
        {
                notification && (
                <>
                <InputLabel id="ID">{'ID'}</InputLabel>
                <TextField 
                    value={notification?.id} 
                    disabled 
                    id='ID' 
                    size='small' 
                    style={{marginBottom:'15px'}}
                /></>)
        }
        {
        <Grid container spacing={4} style={{marginBottom:'30px'}}>
            <Grid item xs={4} sm={4}>
                <InputLabel id="project">{translate('ra.field.type') + ' *'}</InputLabel>
                {
                    isFetchingData ?
                        <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                        <Select
                            id='project'
                            required
                            fullWidth
                            disabled = {mode === 'show'}
                            size='small'
                            onChange={
                                (value)=>{
                                    handleChange(value, 'project_id'); 
                                    if(value){setFormError({...formError,project:false})}
                                }
                            }
                            defaultValue={''}
                            value={form.project_id}
                            renderValue={value=> value && projects.find(project => project.id === value)?.name}
                        >
                            <ListSubheader>
                                <TextField
                                    size="small"
                                    autoFocus
                                    placeholder={translate('ra.action.search')}
                                    fullWidth
                                    value={projectFilter}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        setProjectFilter(e.target.value)
                                    }}
                                    onClick={(e) => e.stopPropagation()} // prevent closing on click
                                    onKeyDown={(e) => e.stopPropagation()}
                                />
                            </ListSubheader>
                            {projectsLoading ?
                                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                                :filteredProjects?.map(project=>(
                                <MenuItem key={project.id} value={project.id}>
                                    {project.name}
                                </MenuItem>
                            ))} 
                        </Select>
                }
                {formError.project && <label htmlFor="project" style={{color:'red'}}>{translate('ra.validation.fieldIsRequired')}</label>}
                
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel id="for">{translate('ra.field.for')}</InputLabel>
                {isFetchingData ?
                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                    <Select
                        fullWidth
                        required
                        disabled = {mode === 'show'}
                        id='for'
                        size='small'
                        onChange={(value)=>{handleChange(value, 'assigned_to_id')}}
                        defaultValue={''}
                        value={form.assigned_to_id}
                        renderValue={(value)=> {let found_member = null; value && (found_member = memberships
                            /* .filter(member=>member?.user) */
                            .find(member=>
                                member?.user ? member.user?.id === value :
                                member.group?.id === value
                                
                            ));
                            const label = found_member?.user
                            ? found_member.user.name
                            : found_member?.group?.name;
                            return (
                                 <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        pr: 1,
                                    }}
                                >
                                    <Typography variant="body3" noWrap>{label}</Typography>
                                    {mode === 'create' && <IconButton
                                        sx={{
                                            position: 'absolute',
                                            right: 4,
                                            top: '50%',
                                            marginRight:'20px',
                                            transform: 'translateY(-50%)',
                                            padding: '4px', // keep small footprint
                                            zIndex: 1,
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation(); // prevent dropdown from opening
                                            handleChange('', 'assigned_to_id'); // clear the selection
                                        }}
                                        onMouseDown={(e) => {
                                            e.stopPropagation(); // prevent MUI from opening the menu
                                        }}
                                    >
                                    <CloseIcon fontSize="small" />
                                    </IconButton>}
                                </Box>
                            ) 
                        }}
                    >   
                        <ListSubheader >
                        <TextField
                            size="small"
                            autoFocus
                            placeholder={translate('ra.action.search')}
                            fullWidth
                            value={membersFilter}
                            onChange={(e) => {
                                e.stopPropagation()
                                setMembersFilter(e.target.value)
                            }}
                            onClick={(e) => e.stopPropagation()} // prevent closing on click
                            onKeyDown={(e) => e.stopPropagation()}
                           
                        />
                    </ListSubheader>
                    {projectsLoading ?
                            <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                        :([

                        <MenuItem key={-1} disabled style={{fontWeight:'bold'}}>
                            {translate('ra.field.user')}
                        </MenuItem>,   
                            ...filteredMembers?.filter(member=>member.user)
                            .map(member => (
                                <MenuItem style={{justifyContent:'space-between'}} key={member.user?.id } value={member.user?.id }>
                                    {member.user ? member.user.name : ''}
                                </MenuItem>
                            )),
                        <MenuItem key={-2} disabled style={{fontWeight:'bold'}}>
                            {translate('ra.field.group')}
                        </MenuItem>
                        ,  
                            ...filteredMembers?.filter(member=>member.group)
                            .map(member => (
                                <MenuItem style={{justifyContent:'space-between'}}  key={ member.group?.id} value={member.group?.id }>
                                    {member.group ? member.group.name : ''}
                                </MenuItem>
                            ))
                    
                        ])}
                    </Select>
                }
                
            </Grid>
            <Grid item xs={4} sm={4}>
            <InputLabel id="follower">{translate('ra.field.follower')}</InputLabel>
            {isFetchingData ?
                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                :
                <Select
                    id='follower'
                    fullWidth
                    disabled = {mode === 'show'}
                    multiple
                    size='small'
                    defaultValue={[]}
                    value = {form.watchers ?? []}
                    onChange={(value)=>handleChange(value, 'watchers')}
                    renderValue={(values)=>{
                        return values && (
                            memberships?.filter(member=>
                                member?.user &&
                                values.includes(member?.user?.id)
                            )
                            .map(member=> 
                                member?.user?.name
                            )
                            .join(', ')
                            )
                        }}
                >
                    <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            placeholder={translate('ra.action.search')}
                            fullWidth
                            value={followersFilter}
                            onChange={(e) => {
                                e.stopPropagation()
                                setFollowersFilter(e.target.value)
                            }}
                            onClick={(e) => e.stopPropagation()} // prevent closing on click
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                    </ListSubheader>
                    {projectsLoading ?
                            <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                        :filteredFollowers?.filter(member=>member.user)
                        .map(member => (
                            <MenuItem key={member.user?.id } value={member.user?.id }>
                                <Checkbox checked={form.watchers?.includes(member.user?.id )} />
                                <ListItemText primary={member.user ? member.user.name : ''}/>
                            </MenuItem>
                        ))} 
                </Select>
            }
            
            </Grid>
            {!record && <Grid item xs={4} sm={4}>
                <InputLabel id="reserve">{translate('ra.field.reserve')}</InputLabel>
                {
                    isFetchingData ?
                        <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                        <Select
                            id='reserve'
                            required
                            fullWidth
                            multiple
                            disabled = {mode === 'show'}
                            size='small'
                            onChange={(value)=>{
                                const mappedValues = value.target.value?.map(reserve=>searchReserveByNumber(reserve))
                                setReservationIDs(mappedValues) 
                                handleChange(value, 'reservation')
                            }}
                            defaultValue={[]}
                            value={form.reservation?? []}
                            renderValue={(value)=>(value.join(', '))}
                        >
                            <ListSubheader>
                                <TextField
                                    size="small"
                                    autoFocus
                                    placeholder={translate('ra.action.search')}
                                    fullWidth
                                    value={reservesFilter}
                                    onChange={(e) => {
                                        setReservesFilter(e.target.value)
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => e.stopPropagation()}
                                />
                            </ListSubheader>
                            {projectsLoading ?
                                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                                :reserves?.map(reserve=>(
                                <MenuItem key={reserve.number} value={reserve.number}>
                                    {reserve.number}
                                    {form.reservation.includes(reserve.number) &&<CloseIcon />}
                                </MenuItem>
                            ))} 
                        </Select>
                }
                
            </Grid>}
            {(mode === 'reply' || mode === 'edit' || mode === 'show') && 
            <Grid item xs={4} sm={4}>
                <InputLabel id="status">{translate('ra.field.status')}</InputLabel>
                {isFetchingData ?
                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                    <Select
                        fullWidth
                        required
                        disabled = {mode === 'show'}
                        id='status'
                        size='small'
                        onChange={(value)=>{handleChange(value, 'status_id')}}
                        defaultValue={''}
                        value={form.status_id}
                        renderValue={(value)=> {let found_status = null; value && (found_status = statuses
                            .find(status=>
                                status?.id === value
                            ));
                            return found_status?.name 
                        }}
                    >
                        {
                            statuses?.filter(status=>status.id !== 15)
                            .map(status => (
                                <MenuItem key={status.id } value={status.id }>
                                    {status.name}
                                </MenuItem>
                            ))
                        }
                    </Select>
                }
                
            </Grid>}
            {record && <Grid item xs={4} sm={4}>
                <InputLabel id="item">{translate('ra.field.assign_item')}</InputLabel>
                {isFetchingData ?
                    <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                    <Select
                        fullWidth
                        required
                        disabled = {mode === 'show'}
                        id='item'
                        size='small'
                        onChange={(value)=>{
                            let found_item = null; 
                            value && (found_item = items
                                .find(item=>
                                    item?.id === value.target.value
                                ));
                            setForm({...form, item:found_item?found_item.name:''})
                        }}
                        defaultValue={''}
                        value={form.item}
                        renderValue={(value)=> {
                            return form.item
                        }}
                    >
                        <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            placeholder={translate('ra.action.search')}
                            fullWidth
                            value={itemsFilter}
                            onChange={(e) => {
                                e.stopPropagation()
                                setitemsFilter(e.target.value)
                            }}
                            onClick={(e) => e.stopPropagation()} // prevent closing on click
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                    </ListSubheader>
                    {projectsLoading ?
                            <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                        :filteredItems?.map(item => (
                            <MenuItem key={item.id } value={item.id }>
                                {item.name}
                            </MenuItem>
                        ))} 
                    </Select>
                }
                
            </Grid>}
        </Grid>}
        {
            <div style={{width:'60%', marginBottom:'30px'}}>
                <InputLabel id="subject">{translate('ra.field.subject')+ ' *'}</InputLabel>
                {
                    isFetchingData ? 
                        <Skeleton variant='rectangular' width={'100%'} height={40} /> 
                    :
                        <TextField 
                            value={form?.subject} 
                            disabled = {mode === 'show'} 
                            onChange={value=>{handleChange(value, 'subject');if(value){setFormError({...formError,subject:false})}}} 
                            id='subject' 
                            size='small' 
                            sx={{width:'100%'}}
                        />
                }
                {formError.subject && <label htmlFor="subject" style={{color:'red'}}>{translate('ra.validation.fieldIsRequired')}</label>}
            </div>
        }
        <div style={{marginBottom:'30px', width:'60%'}}>
            {/* (mode !== 'show' && mode !== 'reply') &&  */<TemplateComponent field={'description'}/>}
            
            {
                isFetchingData ? 
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                :
                    <TextField 
                        value={form?.description}  
                        disabled = {mode === 'show' || mode === 'reply'} 
                        multiline 
                        minRows={3}
                        onChange={value=> handleChange(value, 'description')} 
                        id="description" 
                        InputProps={{
                            /* inputComponent: CustomTextarea, */
                            sx: {
                                textarea: {
                                  resize: 'vertical',
                                },
                              },
                        }}
                        
                        sx={{ width: '100%', marginBottom:'15px'
                        }}
                    />
            }
            {mode === 'reply' &&
                <>
                    <TemplateComponent field={'message'}/>
                    {isFetchingData ? 
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                    :
                        <TextField 
                            value={form?.notes}  
                            multiline 
                            minRows={3}
                            onChange={value=> handleChange(value, 'notes')} 
                            id="message" 
                            InputProps={{
                                /* inputComponent: CustomTextarea, */
                                sx: {
                                    textarea: {
                                      resize: 'vertical',
                                    },
                                  },
                            }}
                            sx={{ width: '100%'}}
                        />}
                </>
            }
            
        </div>

        {(mode !== 'show')&&
        <div className='inputFile' style={{marginBottom:'15px'}}>
            
            {
                isFetchingData ?
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                :
                    <>
                        <label htmlFor="fileInput" /* onClick={downloadFile}  */style={{width:'100%', alignItems:'center', justifyContent:'center', display:'flex'}}>
                            <input
                            type="file"
                            disabled = {mode === 'show'}
                            id="fileInput"
                            style={{ display: "none", cursor:'pointer' }}
                            onChange={handleFileChange}
                        />
                        {(mode !== 'show' && selectedFile.length === 0)&&
                            <div  variant="contained" component="span" style={{cursor:'pointer'}}>
                                {translate('ra.action.add_file')}
                            </div>
                        }
                        {selectedFile.length > 0 && (<label htmlFor="fileInput" style={{cursor:'pointer'}}>
                            {selectedFile[0].name}
                            <input
                                type="file"
                                disabled = {mode === 'show'}
                                id="fileInput"
                                style={{ display: "none"}}
                                onChange={handleFileChange}
                            />
                        </label>) }
                        {/* {(files.length > 0 && mode === 'show') ?
                            <div style={{cursor:'pointer', flexDirection:'row', display:'flex'}} onClick={()=>{setEditFiles(!editFiles)}}>{translate('ra.action.download')} <DownloadIcon/></div>:
                            ''} */}
                        </label>
                        {(/* (mode === 'edit' || mode === 'reply') && */ (selectedFile.length > 0 || files.length > 0)) && <EditIcon onClick={()=>{setEditFiles(!editFiles)}} style={{margin:'15px', cursor:'pointer'}}/>}
                    </>
            }
            
        </div>}
        {(editFiles || (mode === 'show')) && 
        <div style={{display:'flex', flexDirection:'column'}}>
            {
                selectedFile && 
                (
                selectedFile.map((file, index) =>(
                    <div key = {index} style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                        <label style={{alignItems:'center'}}>{file?.name} </label>
                        {/* (mode === 'edit' || mode === 'reply') &&  */<CloseIcon style={{cursor:'pointer'}} onClick={()=>{
                            let auxFiles = [...selectedFile]
                            auxFiles.splice(index, 1)
                            setSelectedFile(auxFiles); fileInput.value = null
                        }}/>}
                    </div>
                ))
                )
            }
            {files?.length > 0 &&
                files.map(noti=>(
                    <div key={noti.id} style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                        {console.log("fileee", noti)}
                        <label>
                            {noti.filename}
                        </label>
                        {(mode === 'edit' || mode === 'reply') && <CloseIcon onClick = {()=>removeFile(noti.filename)} style={{cursor:'pointer'}} />}
                        <DownloadIcon onClick={()=>{downloadParticularFile(noti.filename)}} style={{cursor:'pointer'}}/>
                    </div>
                ))
            }
        </div>}
        {(mode === 'show' || mode === 'edit' || mode === 'reply') &&
        <div>
            <LoadingButton disabled={notification?.journals.length === 0} onClick={()=>{setOpenDetails(!openDetails)}}>
                {
                translate('ra.action.view_history')
                }
            </LoadingButton>
        </div>
        }
        {
            openDetails &&
            <div style={{borderWidth:'1px', borderStyle:'solid', marginTop:'10px', width:'70%'}}>
                {
                    journals?.map(journal=>(
                        <>
                            <div key={journal.id} style={{display:'flex', flexDirection:'row', margin:'15px', justifyContent:'space-between'}}>
                                <label style={{width:'40%'}}>
                                    {parseDateFormat(journal.created_on)}
                                </label>
                                <div style={{width:'60%'}}>
                                    <label>
                                        {journal.user?.name}
                                    </label>
                                    {
                                        journal.notes && 
                                        <FormatHistoryNote text={journal.notes}/>
                                        
                                    }
                                    {
                                        journal?.details && 
                                        journal.details.map((detail, index)=>(
                                            <div key={detail.name}>
                                                {(
                                                    index > 0  && detail.property !== 'attr' && 
                                                    detail.name !== 'done_ratio') || journal.notes ?
                                                <label >
                                                    {` ${translate('ra.message.and')} `}
                                                </label>:''}
                                                {
                                                (detail.property === "attachment" && detail.new_value) ?
                                                <label >
                                                    {` ${translate('ra.message.file_added',{file:detail.new_value})}`}
                                                </label> :
                                                (detail.property === "attachment" && detail.old_value) ?
                                                <label >
                                                    {` ${translate('ra.message.file_removed',{file:detail.old_value})}`}
                                                </label> :
                                                detail.property === "attr" && detail.name === 'status_id'?
                                                <label >
                                                    {` ${translate('ra.message.change_status',{status:statuses.find((status)=>
                                                            status.id === Number(detail.new_value)
                                                        )?.name})}`}
                                                </label> :
                                                detail.property === "cf" && detail.name === '3' && detail.new_value?
                                                <label >
                                                    {` ${translate('ra.message.added_reservation', {reservation:detail.new_value})}`}
                                                </label>:
                                                detail.property === "cf" && detail.name === '3' && detail.old_value?
                                                <label >
                                                    {` ${translate('ra.message.removed_reservation', {reservation:detail.old_value})}`}
                                                </label>:
                                                detail.property === "attr" && detail.name === 'subject' && detail.new_value?
                                                <label >
                                                    {` ${translate('ra.message.changed_subject', {subject:detail.old_value})}`}
                                                </label>:
                                                detail.property === "attr" && detail.name === 'description' && detail.new_value?
                                                <label >
                                                    {` ${translate('ra.message.changed_description', {description:detail.new_value})}`}
                                                </label>:
                                                detail.property === "cf" && detail.name === '1' && detail.new_value?
                                                <label >
                                                    {` ${translate('ra.message.assign_item', {item:detail.new_value})}`}
                                                </label>:
                                                detail.property === "attr" && detail.name === 'project_id' && detail.new_value?
                                                <label >
                                                    {` ${translate('ra.message.changed_type', {type:projects.find((project)=>
                                                            project.id === Number(detail.new_value)
                                                        )?.name})}`}
                                                </label>:
                                                detail.property === "attr" && detail.name === 'assigned_to_id' && detail.new_value?
                                                <label >
                                                    { `${translate('ra.message.assigned_to', {user:getUserGroupName(detail)})}`}
                                                </label>:
                                                detail.property === "attr" && detail.name === 'priority_id' && detail.new_value?
                                                <label >
                                                    { `${translate('ra.message.changed_priority', {old_priority: detail.old_value, new_priority: detail.new_value})}`}
                                                </label>
                                                :
                                                detail.property === "attr" && detail.name === 'tracker_id' && detail.new_value?
                                                <label >
                                                    { `${translate('ra.message.changed_tracker_id', {new_tracker_id: detail.new_value})}`}
                                                </label>: 
                                                detail.property === "cf" && detail.name === '10' && detail.old_value?
                                                <label >
                                                    { `${translate('ra.message.added_link', {new_link: detail.old_value})}`}
                                                </label>:''
                                                }
                                            </div>
                                        ))
                                        
                                    }
                                </div>
                            </div>
                        </>
                    ))
                }
                {notification && <div style={{margin:'15px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                    <label style={{width:'40%'}}>{parseDateFormat(notification?.created_on)}</label>
                    <label style={{width:'60%'}}>{translate('ra.message.add_notification',{user:notification?.author.name})}</label>
                </div>}
            </div>
        }
        <LoadingButton loading={isSaveLoading || isFetchingData} onClick={onSaveForm} style={{marginTop:'30px'}} variant='contained' startIcon={
            (mode === 'edit' || mode === 'create') && <SaveIcon />
        } >
            {
                mode === 'show' ? translate('ra.action.back') : 
                mode === 'reply' ? translate('ra.action.send') :
                (mode === 'edit' || mode === 'create') ? translate('ra.action.save') : ''
            }
        </LoadingButton>
    </div>
  )
}

const CustomTextarea = forwardRef(function CustomTextarea(props, ref) {
    return (
      <Box
        component="textarea"
        ref={ref}
        {...props}
        style={{
          height: '100%',
          overflowY: 'auto',
          resize: 'none',
          padding: '16.5px 14px', // match MUI padding
        }}
      />
    );
  });

NotificationForm.defaultProps = {
    mode:'create',
    notificationId:64803
}




